const COLS = [
  {
    title: "Send + receive",
    links: [
      "Send money in app",
      "Send money online",
      "Send money at location",
      "Receive money",
    ],
  },
  {
    title: "Services",
    links: [
      "MoneyGram Debit Card",
      "MoneyGram Wallet",
      "Buy and sell crypto",
      "Bill pay",
      "Mobile top-ups",
      "Money Orders",
      "Referral program",
    ],
  },
  {
    title: "Business",
    links: [
      "Digital partnerships",
      "Developer portal",
      "Banking solutions",
      "Biller solutions",
    ],
  },
  {
    title: "Corporate",
    links: [
      "About MoneyGram",
      "Careers",
      "MoneyGram blog",
      "Newsroom",
      "Social impact",
      "MoneyGram Haas F1 team",
      "Feedback",
      "Report fraud",
    ],
  },
  {
    title: "Legal information",
    links: [
      "Terms & conditions",
      "Crypto terms and conditions",
      "Terms of use",
      "Compliance",
      "Cookie preferences",
      "Privacy center",
      "Legal notices",
      "ADA accessibility statement",
      "State licenses",
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="site-footer mt-12">
      <div className="max-w-page mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {COLS.map((col) => (
            <div key={col.title}>
              <div className="col-title">{col.title}</div>
              {col.links.map((l) => (
                <a key={l} href="#" className="col-link">
                  {l}
                </a>
              ))}
            </div>
          ))}
        </div>
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="bg-mg-red w-7 h-7 rounded-full flex items-center justify-center font-bold text-white text-sm">
                M
              </div>
              <span className="font-display font-bold text-white">
                MoneyGram
              </span>
            </div>
          </div>
          <p className="text-[11px] text-slate-400 max-w-3xl leading-relaxed">
            ©2026 MoneyGram. MoneyGram and the Globe are marks of MoneyGram. All
            other marks are the property of their respective owners. Not all
            services are available in all countries. Fees vary based on
            transaction details such as transfer amount, payment type, delivery
            method, and pickup location. MoneyGram Payment Systems, Inc. is
            licensed as a Money Transmitter by the New York State Department of
            Financial Services.
          </p>
        </div>
      </div>
    </footer>
  );
}
